import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '../services/login.service';

/**
 * Guard funcional - exige sessao ativa e (opcional) privilegios na rota.
 *
 * Como declarar privilegios numa rota:
 *   { path: 'notas-list', canActivate: [authGuard],
 *     data: { requiredPrivileges: ['VIEW'] } }
 *
 * O guard cruza a rota Angular com o array `menus` do JWT (gravado no
 * localStorage no login). Cada menu tem { id, rota, privileges } - o match
 * e feito por `rota` (mais estavel que id, que muda conforme o cadastro).
 */
export const authGuard: CanActivateFn = (route, _state) => {
  const loginService = inject(LoginService);
  const router = inject(Router);

  if (!loginService.isLogged()) {
    router.navigate(['/login']);
    return false;
  }

  const required: string[] = route.data?.['requiredPrivileges'] ?? [];
  if (required.length === 0) return true;

  const path = route.routeConfig?.path ?? '';
  const rota = path.startsWith('/') ? path : '/' + path;

  const ok = required.every(p => loginService.hasPrivilegeByRota(rota, p));
  if (!ok) {
    router.navigate(['/acesso-negado']);
    return false;
  }
  return true;
};
